import React, { useEffect, useRef, useState } from "react";
import { Typography } from "@material-ui/core";
import Modal from "@/components/Modal";
import { toast } from "@/apis/request";
import CategoryTree from "@/containers/GroupsDevices/Category/CategoryTreeWrapper";
import { useTranslation } from "@/langs/useTranslation";
import { useUpdateEffect } from "ahooks";

function TransferGroupModal({
  open,
  title,
  description,
  excludeKeys,
  checkedKeys: checkedKeysFromProps,
  defaultCheckAll = true,
  userMode = true,
  checkEmpty = true,
  onConfirm,
  onClose
}) {
  const { t } = useTranslation();
  const checked = useRef([]);
  const allKeysRef = useRef([]);
  const tree = useRef(null);
  const [checkedKeys, setCheckedKeys] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const handleClose = () => {
    setLoaded(false);
    onClose?.();
  };

  const handleConfirm = () => {
    if (checkEmpty && !checked.current.length) {
      toast.info(t({ defaultMessage: "请选择一个门店" }));
      return;
    }
    const unChecked = allKeysRef.current.filter(
      key => !checked.current.includes(key) // && key !== "default"
    );
    const newExcludeKeys = excludeKeys
      ? excludeKeys.filter(key => !checked.current.includes(key))
      : [];
    setLoaded(false);
    return onConfirm?.(
      checked.current,
      Array.from(new Set([...unChecked, ...newExcludeKeys]))
    );
  };

  const handleCheck = checkedKeys => {
    checked.current = checkedKeys;
  };

  const descriptionSlot =
    description === false
      ? null
      : description || (
          <Typography
            variant="body2"
            color="textSecondary"
            style={{ marginTop: 16 }}
          >
            {t({ defaultMessage: "勾选要归属的门店，代表拥有该门店的权限" })}
          </Typography>
        );

  const onLoaded = () => {
    setLoaded(true);
  };

  useUpdateEffect(() => {
    if (open && loaded && defaultCheckAll) {
      const allKeys = tree.current?.getFlattenTreeData().map(item => item.key);
      if (allKeys) {
        allKeysRef.current = allKeys;
        if (excludeKeys) {
          setCheckedKeys(allKeys.filter(key => !excludeKeys.includes(key)));
        } else {
          setCheckedKeys(allKeys);
        }
      }
    }
  }, [open, loaded, excludeKeys]);

  useUpdateEffect(() => {
    checked.current = checkedKeys;
  }, [checkedKeys]);

  useEffect(() => {
    if (checkedKeysFromProps) {
      setCheckedKeys(checkedKeysFromProps);
    }
  }, [checkedKeysFromProps]);

  return (
    <Modal
      title={title || t({ defaultMessage: "归属门店" })}
      width={576}
      open={open}
      onClose={handleClose}
      onConfirm={handleConfirm}
    >
      <CategoryTree
        ref={tree}
        showAll={false}
        showSwitch={false}
        collapse={false}
        selectable={false}
        checkStrictly
        checkedKeys={checkedKeys}
        // defaultSelectAll
        userMode={userMode}
        readOnly
        checkable
        description={descriptionSlot}
        onCheck={handleCheck}
        onLoaded={onLoaded}
      />
    </Modal>
  );
}

export default TransferGroupModal;
